import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-catering-site',
  templateUrl: './catering-site.component.html',
  styleUrls: ['./catering-site.component.scss']
})
export class CateringSiteComponent {

  public constructor(
    private meta: Meta,
    private router: Router,
    private route: ActivatedRoute
  ) {
    let baseurl = window.location.protocol + '//' + window.location.hostname;
    this.meta.updateTag({
      name: 'og:url',
      content: baseurl + this.router.url
    });
    this.meta.updateTag({
      name: 'og:type',
      content: 'website'
    });
    this.meta.updateTag({
      name: 'og:image',
      content: baseurl + '/assets/images/social/MDCAT-0-001-Social-1200x630.jpg'
    });

  }

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  toMainConent() {
    this.router.navigate([location.pathname], { fragment: 'main-content' })
  }

}
